import React, { useState } from "react";
import { useLang } from "@/i18n";
import Reveal from "@/components/Reveal";
import { Link } from "react-router-dom";
import { X } from "lucide-react";

const CDN = "https://customer-assets-lxgj4vgw.emergentagent.net/job_huitzil-tours/artifacts";
const VIDEO_URL = "/hero.mp4";

export const GALLERY = [
  { src: `${CDN}/9drwekb0_DSC_0021.webp`, es: "Despegue al amanecer: el quemador ilumina la canasta", en: "Sunrise lift-off: the burner lights up the basket", span: "col-span-6 md:col-span-4 row-span-2" },
  { src: `${CDN}/qh9kt054_CC1CD315-C48A-40A7-A5BE-B1854B4DAE0F.PNG`, es: "Un amanecer para dos frente a los globos", en: "A sunrise for two in front of the balloons", span: "col-span-3 md:col-span-2 row-span-2" },
  { src: `${CDN}/c46xp82k_DSC_0008.webp`, es: "Momentos que se vuelven recuerdos", en: "Moments that become memories", span: "col-span-3 md:col-span-2 row-span-2" },
  { src: `${CDN}/38suwqjg_DSC_0017.webp`, es: "Dentro de la canasta, listos para volar", en: "Inside the basket, ready to fly", span: "col-span-6 md:col-span-4 row-span-2" },
  { src: `${CDN}/8d46cqu2_DSC_0022.webp`, es: "Sonrisas antes del despegue", en: "Smiles before lift-off", span: "col-span-3 md:col-span-2 row-span-2" },
  { src: `${CDN}/qeyly0rc_DSC_0014.webp`, es: "Amigos celebrando entre globos", en: "Friends celebrating among balloons", span: "col-span-3 md:col-span-2 row-span-2" },
  { src: `${CDN}/sxw60svk_DSC_0045.webp`, es: "La aventura empieza en tierra", en: "The adventure starts on the ground", span: "col-span-3 md:col-span-2 row-span-2" },
  { src: `${CDN}/1jtbdodi_DSC_0023.webp`, es: "La selfie obligada antes de subir", en: "The must-have selfie before boarding", span: "col-span-3 md:col-span-2 row-span-2" },
];

export default function ExperiencesPage() {
  const { t, lang } = useLang();
  const [open, setOpen] = useState(null);
  return (
    <div data-testid="experiences-page" className="pt-32 md:pt-40 pb-24">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12">
        <p className="eyebrow mb-5">{t("editorial.kicker")}</p>
        <h1 className="font-serif-hc font-light text-5xl md:text-7xl leading-[1.02] text-[#F5F2EA]">
          {t("editorial.title_a")} <span className="italic text-[#C4A661]">{t("editorial.title_b")}</span>
        </h1>
        <p className="mt-6 max-w-2xl text-[#A3A095] text-lg leading-relaxed">{t("gallery.body")}</p>

        <Reveal className="mt-16 relative aspect-video md:aspect-[21/9] overflow-hidden bg-[#111]" data-testid="intro-video-slot">
          <video
            data-testid="intro-video"
            src={VIDEO_URL}
            poster={GALLERY[0].src}
            className="w-full h-full object-cover"
            autoPlay
            muted
            loop
            playsInline
            controls
          />
          <p className="absolute top-5 left-5 pointer-events-none text-[#F5F2EA] font-serif-hc text-xl md:text-2xl drop-shadow">{t("gallery.video_title")}</p>
        </Reveal>

        <div className="mt-6 grid grid-cols-6 gap-3 md:gap-4 auto-rows-[160px] md:auto-rows-[220px]">
          {GALLERY.map((g, i) => (
            <Reveal key={g.src} delay={i * 80} className={`${g.span} overflow-hidden relative group cursor-pointer`}>
              <button data-testid={`gallery-photo-${i}`} onClick={() => setOpen(i)} className="w-full h-full block">
                <img src={g.src} alt={g[lang] || g.es} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition duration-700" />
                <span className="absolute inset-x-0 bottom-0 p-4 text-left text-sm text-[#F5F2EA] bg-gradient-to-t from-black/70 to-transparent opacity-0 group-hover:opacity-100 transition">{g[lang] || g.es}</span>
              </button>
            </Reveal>
          ))}
        </div>

        <div className="mt-16 text-center">
          <Link to="/tours" className="hc-btn-secondary">{t("tours.all")}</Link>
        </div>
      </div>

      {open !== null && (
        <div data-testid="gallery-lightbox" onClick={() => setOpen(null)} className="fixed inset-0 z-[100] bg-black/90 flex items-center justify-center p-4 md:p-10">
          <button data-testid="gallery-lightbox-close" className="absolute top-5 right-5 text-[#F5F2EA]" onClick={() => setOpen(null)}><X size={28} /></button>
          <figure className="max-h-full flex flex-col items-center gap-4" onClick={(e) => e.stopPropagation()}>
            <img src={GALLERY[open].src} alt="" className="max-h-[80vh] max-w-full object-contain" />
            <figcaption className="text-[#A3A095] text-sm">{GALLERY[open][lang] || GALLERY[open].es}</figcaption>
          </figure>
        </div>
      )}
    </div>
  );
}
